// src/services/supabase.ts - Clean and simple
import {createClient} from '@supabase/supabase-js';
import type {Database} from '@/types/database';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
    },
});

// Helper function for handling Supabase errors
export const handleSupabaseError = (error: any, context: string) => {
    console.error(`Supabase error in ${context}:`, error);

    // Common PostgreSQL error codes
    if (error?.code === 'PGRST116') {
        throw new Error('No records found');
    }

    if (error?.code === '23503') {
        throw new Error('Cannot delete record: it has dependent records');
    }

    if (error?.code === '23505') {
        throw new Error('A record with this information already exists');
    }

    if (error?.code === '42501') {
        throw new Error('Insufficient permissions to perform this action');
    }

    if (error?.code === 'PGRST301') {
        throw new Error('Row Level Security policy violation');
    }

    if (error?.message?.includes('JWT')) {
        throw new Error('Authentication token is invalid or expired');
    }

    // Default error handling
    throw new Error(error?.message || 'An unexpected error occurred');
};
